import { jsx as _jsx } from "react/jsx-runtime";
import HomePage from "@/core/components/page/HomePage";
import NotFoundPage from "@/core/components/error/NotFoundPage";
import AllProductsPage from "@/core/components/shop/Product/AllProductsPage";
import OrderIncompletePage from "@/core/components/page/OrderIncomplete"; // Update this line
import ThankYouPage from "@/core/components/page/ThankYouPage";
const routes = [
    {
        path: "/",
        element: _jsx(HomePage, {}),
    },
    {
        path: "/products",
        element: _jsx(AllProductsPage, {}),
    },
    {
        path: "/thank-you",
        element: _jsx(ThankYouPage, {}),
    },
    {
        path: "/order-incomplete",
        element: _jsx(OrderIncompletePage, {}),
    },
    {
        path: "*",
        element: _jsx(NotFoundPage, {}),
    },
];
export default routes;
